<template>
  <figure class="run-app">
    <figcaption>Loading...</figcaption>
    <img src="../../../assets/images/loading.gif" alt="" />
  </figure>
</template>

<script>
import { RepositoryFactory } from "../../../api/RepositoryFactory";
export default {
  async mounted() {
    const accessToken = this.$route.query.access_token;
    const eventFlag = sessionStorage.getItem("event_flag") ? "company/" : "";
    const data = {
      event_id: sessionStorage.getItem("eventId"),
      email: sessionStorage.getItem("email"),
      app_auth_code: sessionStorage.getItem("app_auth_code"),
      event_flag: eventFlag,
      access_token: accessToken,
      lang: this.lang,
    };
    let runnerName = "";
    try {
      const OauthUserRepository = RepositoryFactory.get("oauth");
      const response = await OauthUserRepository.postRegister(data);
      runnerName = response.data.runner_name;
    } catch (e) {
      await this.$router.push(
        `/${this.langPath}${eventFlag}link?register=failure`
      );
    }
    await this.$router.push(
      `/${this.langPath}${eventFlag}link?register=success&runner_name=${runnerName}`
    );
  },
  computed: {
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  name: "RunApp",
};
</script>

<style scoped>
.run-app {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/runapp/RunApp.vue